import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { FieldChangeCallBackArgs, FieldItem } from '@lib/interfaces/form';
import Select from '@lib/components/Select/Select';
import { GetLoadOptions, SelectOption } from '@lib/components/Select/types';
import { getOptionValidation } from '@lib/utils/validationUtils';
import WidgetFieldNames from '@lib/enums/fieldNames/widgetFieldNames';
import WidgetSingleValue from '../../components/WidgetSingleValue';
import WidgetOption from '../../components/WidgetOption';

/**
 * Returns fields for the main widget selector
 */
export default function getWidgetSelectorField(
  t: TFunction,
  getWidgetTemplatesLoadOptionsParam: GetLoadOptions,
  isEditMode?: boolean,
  onWidgetChange?: (widgetOption: SelectOption | null) => void,
): FieldItem[] {
  return [
    {
      name: WidgetFieldNames.Widget,
      label: isEditMode
        ? t('home.select-widget-type')
        : t('home.select-widget'),
      element: Select,
      validation: getOptionValidation({ t, required: true }),
      componentProps: {
        defaultOptions: false,
        isAsync: true,
        getLoadOptions: getWidgetTemplatesLoadOptionsParam,
        isClearable: false,
        isSearchable: !isEditMode,
        maxMenuHeight: 400,
        usePortal: true,
        disabled: isEditMode,
        components: {
          Option: WidgetOption,
          SingleValue: WidgetSingleValue,
        },
      },
      fieldChangeCallBack: ({
        values,
        type,
        name,
      }: FieldChangeCallBackArgs) => {
        if (
          type === 'change' &&
          name === WidgetFieldNames.Widget &&
          onWidgetChange &&
          !isEditMode
        ) {
          const widgetOption = _get(
            values,
            WidgetFieldNames.Widget,
          ) as SelectOption | null;
          onWidgetChange(widgetOption);
        }
      },
    },
  ];
}
